<template>
  <div class="corporation_edit">
    <div
      v-for="headerTitle in headerTitles"
      :key="headerTitle.value"
      class="title_header"
      :style="{backgroundColor: headerTitle.color}"
    >
      <div
        class="title_header_value vertical_align_div"
        @click="pageLink(headerTitle.path)"
      >
        <span class="header_router">
          {{ headerTitle.value }}
        </span>
      </div>
    </div>
    <div class="corporation_logs">
      <div class="corporation_logs_background">
        <div class="corporation_logs_left_side">
          <div class="detail_content">
            <div class="total_period_label assessment_title_label">
              {{ tenantNameTitle }}
            </div>
            <div class="tenant_name">
              {{ tenantNameValue }}
            </div>
          </div>
          <targetSection
            :titleLabel="targetSectionTitle"
            @setDefaultFlag="setDefaultFlag()"
          ></targetSection>
          <tortalPeriodSection
            :titleLabel="tortalPeriodSectionTitle"
          ></tortalPeriodSection>
          <radioButtonSection
            v-if="rateFlag"
            :titleLabel="radioButtonSectionTitle"
            :nameValue="ratesTarget"
            @changeFlag="changeRateTargetFlag()"
          ></radioButtonSection>
        </div>
        <div v-show="rateTargetFlag" class="corporation_logs_right_side">
          <assessmentInfoDetail></assessmentInfoDetail>
        </div>
      </div>
      <div class="corporation_bottom">
        <div class="corporation_bottom_buttons">
          <input
            type="button"
            :value="exportButton"
            class="finish_button"
            @click="showExportModal = true"
          />
        </div>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="export_modal_window" v-if="showExportModal">
        <exportModalWindow
          :exportList="checkedList"
          @close="close"
          @export="exportLog"
        >
        </exportModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import targetSection from './logExportCompornents/targetSection.vue'
import tortalPeriodSection from './logExportCompornents/totalPeriodSection.vue'
import radioButtonSection from './logExportCompornents/radioButtonSection.vue'
import assessmentInfoDetail from './logExportCompornents/assessmentInfoDetail.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import exportModalWindow from '../modalWindow/exportModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      exportButton: 'エクスポート',
      tenantNameTitle: 'テナント名',
      targetSectionTitle: 'ログ解析対象',
      tortalPeriodSectionTitle: '対象期間',
      radioButtonSectionTitle: '出力形式',
      ratesTarget: 'rates_target',
      targetValue: '',
      completeWord: '',
      failureWord: '',
      checkedUsersList: [],
      checkedPostsList: [],
      rateTargetFlag: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      showExportModal: false
    }
  },
  computed: {
    headerTitles() {
      return this.$store.state.masters.detailHeaderTitle
    },
    adminUserId() {
      return this.$store.state.corporations.corporation.adminUsers[0]
        .adminUserId
    },
    tenantNameValue() {
      return this.$store.state.corporations.corporation.companyName
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    rateFlag() {
      return this.$store.state.masters.rateFlag
    },
    posts() {
      return this.$store.state.corporations.posts
    },
    users() {
      return this.$store.state.corporations.users
    },
    nowDateTime() {
      var dt = new Date()
      var y = dt.getFullYear()
      var m = ('00' + (dt.getMonth() + 1)).slice(-2)
      var d = ('00' + dt.getDate()).slice(-2)
      return y + m + d
    },
    exportTitle() {
      return (
        this.tenantNameValue +
        '_' +
        this.targetValue +
        '_' +
        this.nowDateTime +
        '.csv'
      )
    }
  },
  async created() {
    this.showloadingModal = true
    try {
      this.$store.dispatch('masters/changeRateFlag', true)
      await this.$store.dispatch(
        'corporations/setUserInfos',
        this.$store.state.corporations.corporation.tenantKey
      )
    } catch (error) {
      let eventNumber = this.$store.state.error.sysErrorCode.sysErrorCode_190001
      if (error.response) {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0075.name +
          this.sysErrorMsg.MSGCRD0075.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRC0005.name +
          this.sysErrorMsg.MSGCRC0005.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
      this.showFailureModal = true
      this.showloadingModal = false
      return
    }
    try {
      await this.$store.dispatch(
        'corporations/setPostInfos',
        this.$store.state.corporations.corporation.tenantKey
      )
    } catch (error) {
      let eventNumber = this.$store.state.error.sysErrorCode.sysErrorCode_190002
      if (error.response) {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0076.name +
          this.sysErrorMsg.MSGCRD0076.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRC0005.name +
          this.sysErrorMsg.MSGCRC0005.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
      this.showFailureModal = true
    }
    this.showloadingModal = false
  },
  components: {
    targetSection,
    tortalPeriodSection,
    radioButtonSection,
    assessmentInfoDetail,
    completeModalWindow,
    exportModalWindow,
    loadingModalWindow
  },
  methods: {
    UserException(message) {
      this.message = message
      this.expectedError = true
    },
    pageLink(path) {
      this.$router.push(path)
    },
    close(e) {
      this.showCompleteModal = false
      this.showFailureModal = false
      this.showExportModal = false
      this.showloadingModal = false
    },
    changeRateTargetFlag(e) {
      this.rateTargetFlag = !this.parseStrToBoolean(event.target.value)
    },
    setDefaultFlag(e) {
      this.rateTargetFlag = this.rateFlag
    },
    initAsUTC(date) {
      var local = new Date(date)
      var offset = local.getTimezoneOffset() / 60
      var utc = new Date(local.getTime() + offset * 60 * 60 * 1000)
      return utc
    },
    async exportLog(e) {
      this.showloadingModal = true
      this.showExportModal = false
      this.checkedUsersList = []
      this.checkedPostsList = []
      let targetList = document.getElementsByName('target')
      this.targetValue = this.setRadioButtonValue(targetList)

      // 評価情報を集計して抽出するかどうかのフラグを取得
      var ratesTargetEnableFlags = document.getElementsByName('rates_target')
      var ratesTargetEnableFlag = this.setRadioButtonValue(
        ratesTargetEnableFlags
      )

      try {
        let allAverageFlag = false
        if (!this.parseStrToBoolean(ratesTargetEnableFlag)) {
          this.createTargetList()
          allAverageFlag = this.checkTargetCount()
        }
        let start = document.getElementById('start_date').value
        let end = document.getElementById('end_date').value
        let startDateTime = ''
        let endDateTime = ''
        if (start !== '') {
          var startDate = new Date(start)
          startDateTime = Date.parse(this.initAsUTC(startDate))
        } else {
          startDateTime = ''
        }
        if (end !== '') {
          var endDate = new Date(end)
          let endSecond = Date.parse(this.initAsUTC(endDate))
          endDateTime = endSecond + 24 * 60 * 60 * 1000 - 1
        } else {
          endDateTime = ''
        }
        if (endDateTime !== '' && startDateTime > endDateTime) {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_190005
          this.failureWord =
            this.sysErrorMsg.MSGCRD0078.name +
            this.sysErrorMsg.MSGCRD0078.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          throw new this.UserException(this.failureWord)
        }

        let countUnits = document.getElementsByName('count_units')
        let countUnit = 0
        for (let i = 0; i < countUnits.length; i++) {
          if (countUnits[i].checked) {
            countUnit = countUnits[i].value
            break
          }
        }
        let postList = []
        let users = this.checkedUsersList
        let posts = this.checkedPostsList
        let sumunit = countUnit

        this.createPostList(
          startDateTime,
          endDateTime,
          users,
          posts,
          sumunit,
          allAverageFlag,
          postList,
          this.rateFlag && this.parseStrToBoolean(ratesTargetEnableFlag)
        )
        // APIのレスポンスデータからエクスポートするログを整形し保持する変数
        let result = ''
        if (this.rateFlag) {
          if (this.parseStrToBoolean(ratesTargetEnableFlag)) {
            await this.getExportLogs(
              'corporations/setRateLogInfos',
              {
                tenantKey: this.$store.state.corporations.corporation.tenantKey,
                rateConditions: postList
              },
              'MSGCRD0079'
            )
            result = await this.createExportLogs(
              this.$store.state.corporations.ratesLogs
            )
          } else {
            await this.getExportLogs(
              'corporations/setRatesInfos',
              {
                tenantKey: this.$store.state.corporations.corporation.tenantKey,
                rateConditions: postList
              },
              'MSGCRD0079'
            )
            result = await this.createExportLogs(
              this.$store.state.corporations.rates
            )
          }
        } else {
          await this.getExportLogs(
            'corporations/setLocationLogInfos',
            postList,
            'MSGCRD0080'
          )
          result = await this.createExportLogs(
            this.$store.state.corporations.locationLogs
          )
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, this.exportTitle)
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', this.exportTitle)
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', this.exportTitle)
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
        } else {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_190009
          this.failureWord =
            this.sysErrorMsg.MSGCRD0083.name +
            this.sysErrorMsg.MSGCRD0083.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFailureModal = true
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_190010
        if (error.expectedError) {
          this.failureWord = error.message
        } else {
          if (error.response) {
            this.failureWord =
              this.sysErrorMsg.MSGCRD0084.name +
              this.sysErrorMsg.MSGCRD0084.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.sysErrorMsg.MSGCRD0001.name +
              this.sysErrorMsg.MSGCRD0001.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
        }
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createTargetList() {
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].checked === true) {
          let userId = this.users[i].userId
          let userName = this.users[i].familyName + this.users[i].name
          this.checkedUsersList.push({userId, userName})
        }
      }
      for (let i = 0; i < this.posts.length; i++) {
        if (this.posts[i].checked === true) {
          let postId = this.posts[i].postId
          let postName = this.posts[i].postName
          this.checkedPostsList.push({postId, postName})
        }
      }
    },
    checkTargetCount() {
      var allAverageFlag = false
      if (document.getElementById('all_checkbox').checked) {
        allAverageFlag = true
        if (
          this.checkedUsersList.length + this.checkedPostsList.length + 1 >
          5
        ) {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_190003
          this.failureWord =
            this.sysErrorMsg.MSGCRD0077.name +
            this.sysErrorMsg.MSGCRD0077.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          throw new this.UserException(this.failureWord)
        }
      } else {
        allAverageFlag = false
        if (this.checkedUsersList.length + this.checkedPostsList.length > 5) {
          let eventNumber = this.$store.state.error.sysErrorCode
            .sysErrorCode_190004
          this.failureWord =
            this.sysErrorMsg.MSGCRD0077.name +
            this.sysErrorMsg.MSGCRD0077.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          throw new this.UserException(this.failureWord)
        }
      }
      return allAverageFlag
    },
    createPostList(
      startDateTime,
      endDateTime,
      users,
      posts,
      sumunit,
      allAverageFlag,
      postList,
      isNoUsersPosts
    ) {
      let postItem = {}
      if (startDateTime === '' && endDateTime === '') {
        postItem = {sumunit, allAverageFlag}
      } else if (startDateTime === '') {
        postItem = {endDateTime, sumunit, allAverageFlag}
      } else if (endDateTime === '') {
        postItem = {startDateTime, sumunit, allAverageFlag}
      } else {
        postItem = {
          startDateTime,
          endDateTime,
          sumunit,
          allAverageFlag
        }
      }
      if (!isNoUsersPosts) {
        postItem.users = users
        postItem.posts = posts
      }
      postList.push(postItem)
    },
    async getExportLogs(URI, postList, sysErrorMsgNo) {
      try {
        await this.$store.dispatch(URI, postList)
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_190006
        if (error.response) {
          this.failureWord =
            this.sysErrorMsg[sysErrorMsgNo].name +
            this.sysErrorMsg[sysErrorMsgNo].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg.MSGCRC0005.name +
            this.sysErrorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        throw new this.UserException(this.failureWord)
      }
    },
    async createExportLogs(target) {
      // APIからレスポンスが返ってきた後の処理
      let result = ''
      if (target[0].title.values.length === 0) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_190007
        this.failureWord =
          this.sysErrorMsg.MSGCRD0081.name +
          this.sysErrorMsg.MSGCRD0081.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        throw new this.UserException(this.failureWord)
      }
      if (target[0].values.length === 0) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_190008
        this.failureWord =
          this.sysErrorMsg.MSGCRD0082.name +
          this.sysErrorMsg.MSGCRD0082.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        throw new this.UserException(this.failureWord)
      }
      if (this.rateFlag) {
        result += target[0].title.date + ','
      }
      for (let i = 0; i < target[0].title.values.length; i++) {
        result += this.exportSetDoubleQuotation(target[0].title.values[i])
        if (i === target[0].title.values.length - 1) {
          result += '\n'
        } else {
          result += ','
        }
      }
      for (let i = 0; i < target[0].values.length; i++) {
        if (this.rateFlag) {
          result += target[0].values[i].date + ','
        }
        for (let j = 0; j < target[0].values[i].values.length; j++) {
          result += this.exportSetDoubleQuotation(target[0].values[i].values[j])
          if (j === target[0].values[i].values.length - 1) {
            result += '\n'
          } else {
            result += ','
          }
        }
      }
      return result
    },
    setRadioButtonValue(radioList) {
      var flagValue
      for (let i = 0; i < radioList.length; i++) {
        if (radioList[i].checked) {
          flagValue = radioList[i].value
          break
        }
      }
      return flagValue
    },
    parseStrToBoolean(str) {
      return str === 'true'
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationLogExport.vue